import './List.css';
import Item from '../Item/Item'
import { BANNER_ACTIVADO, BANNER_EXTENSION, FOOTER_ACTIVADO } from '../../Config.js'

const List = (props) => {
    return (
        <div className={FOOTER_ACTIVADO ? 'list con-footer' : 'list'}>
            {BANNER_ACTIVADO && <img src={`./images/banner.${BANNER_EXTENSION}`} alt='banner' />}
            {props.datos.map((producto, index) => 
                {
                if(producto.Category == props.selec || props.selec == "Todos"
                    && producto.Category != "") {
                    return <Item
                                key={index}
                                name={producto.Name}
                                description={producto.Description}
                                price={producto.Price}
                                image={producto.Image}
                                link={producto.Link}
                            />
                }}
            )}
        </div>
    );
}

export default List;